import React from 'react';

import styles from './Form.scss';

const Navigation = props => {
  const { navigation, isValid, prevDisable, goHome } = props;
  const { previous, next } = navigation;

  function goHomeHandler() {
    location.reload();
  }
  return (
    <div className={styles.form__navigation}>
      <button
        onClick={goHome ? goHomeHandler : previous}
        disabled={prevDisable}
      >
        Previous
      </button>
      <button onClick={next} disabled={!isValid}>
        Next
      </button>
      {!isValid ? (
        <span className={styles.required_feild}>
          Fill all the requiered feilds
        </span>
      ) : (
        <span className={styles.required_feild}>
          Press <span>Enter</span>
        </span>
      )}
    </div>
  );
};

export default Navigation;
